import './EventDescription.css';

import { defaultLoadTransition } from 'lib/styles/Transitions';
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

interface IEventDescriptionProps {
  children: string;
  maxLength?: number;
}

interface IEventDescriptionState {
  collapsed: boolean;
}

export default class EventDescription extends React.Component<
  IEventDescriptionProps,
  IEventDescriptionState
> {
  public state = { collapsed: true };

  constructor(props) {
    super(props);
    this.collapseToggle = this.collapseToggle.bind(this);
  }

  public collapseToggle(e?: any) {
    e.preventDefault();
    this.setState({ collapsed: !this.state.collapsed });
  }

  public render() {
    const newText = this.props.children.split('\n').map((i, x) => {

      if(i.length !== 0) {    
        return <p key={x} style={{fontSize: '14px'}}>{i}</p>
      }
    });

    const { children } = this.props;
    const { collapsed } = this.state;
    if (!children) {
      return null;
    }
    const length = this.props.maxLength || 300;
    return (
      <div className="col-md-12 col-sm-12 text-left" style={{ color: '#151726' }}>
        {children.length > length ? (
          <React.Fragment>
            <ReactCSSTransitionGroup {...defaultLoadTransition}>
              <div>{collapsed ? <p style={{fontSize:'14px'}}>{children.substr(0, length - 1) + '...' }</p>: newText}</div>
            </ReactCSSTransitionGroup>
            <div
              className="EventDescription-show"
              onClick={this.collapseToggle}
            >
              {!collapsed ? "Show Less" : "Show More"}
            </div>
          </React.Fragment>
        ) : (
          children
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/platform/card/modules/EventDescription/EventDescription.tsx